/* Satış bildirimi: gerçek siparişlerden (şehir + ürün, tarihsiz) küçük kart. Ülkeye göre kişiselleşir.
   Veri: window.HN_SALES (hn-sales-data.js), ziyaretçi ülkesi: window.HN_SALES_CFG (snippet'ten). Çerez YOK; sessionStorage yalnız sayaç için. */
(function () {
  'use strict';
  try {
    var D = window.HN_SALES, C = window.HN_SALES_CFG || {};
    if (!D || !D.pool || D.pool.length < 5) return;
    var FIRST = 10000, GAP = 30000, SHOW = 6000, MAX = 5;
    var KEY = 'hnSales', st;
    try { st = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { st = {}; }
    if (st.off || (st.n || 0) >= MAX) return;
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }

    var REG = { gulf: ['AE', 'SA', 'QA', 'BH', 'KW', 'OM'], eu: ['GB', 'FR', 'DE', 'IT', 'ES', 'NL', 'BE', 'CH', 'AT', 'IE', 'PT', 'SE', 'DK', 'FI', 'NO'], asia: ['HK', 'SG'] };
    function region(cc) { for (var k in REG) if (REG[k].indexOf(cc) > -1) return REG[k]; return []; }
    var cc = (C.cc || '').toUpperCase(), reg = region(cc), pool = D.pool;
    function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    var own = shuffle(pool.filter(function (e) { return e.c === cc; }));
    var near = shuffle(pool.filter(function (e) { return e.c !== cc && reg.indexOf(e.c) > -1; }));
    var rest = shuffle(pool.filter(function (e) { return e.c !== cc && reg.indexOf(e.c) < 0; }));
    /* Sıra: kendi ülkesi (en çok 3'ü), bölge, karışık — kendi ülkesi yetersizse (<2) tüm havuz karışık */
    var order = [];
    if (own.length >= 2) { order = own.slice(0, 3); var m = near.concat(rest); for (var i = 0; i < m.length; i++) { order.push(m[i]); if (i % 2 === 1 && own[3 + (i >> 1)]) order.push(own[3 + (i >> 1)]); } }
    else order = near.concat(rest, own);
    var seen = st.seen || [];
    order = order.filter(function (e) { return seen.indexOf(e.h + '|' + e.n) < 0; });
    if (!order.length) return;

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var box = document.createElement('div');
    box.className = 'hn-sp'; box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite');
    document.body.appendChild(box);
    var timer, idx = 0;

    function hide() { box.classList.remove('hn-sp--on'); }
    function show() {
      if (!order[idx] || (st.n || 0) >= MAX) return;
      if (document.hidden) { timer = setTimeout(show, 3000); return; } /* sekme arka plandaysa göstermeden bekle */
      /* e-posta/başka açık katman varken gösterme */
      if (document.querySelector('[role="dialog"][open],.modal--open,.is-open[data-popup]')) { timer = setTimeout(show, 5000); return; }
      var e = order[idx++];
      var url = (C.root || '/') + 'products/' + encodeURIComponent(e.h);
      box.innerHTML = '<a class="hn-sp__a" href="' + esc(url) + '"><img class="hn-sp__i" src="' + esc(e.i) + '" alt="" width="56" height="56" loading="lazy">' +
        '<span class="hn-sp__t"><span class="hn-sp__w"></span><span class="hn-sp__p">' + esc(e.t) + '</span></span></a>' +
        '<button class="hn-sp__x" type="button" aria-label="' + esc(C.close || 'Close') + '">&times;</button>';
      box.querySelector('.hn-sp__w').innerHTML = esc(C.tpl || 'Someone in [city] ordered').replace('[city]', '<b>' + esc(e.n) + '</b>');
      box.querySelector('.hn-sp__x').onclick = function () { st.off = 1; save(); hide(); clearTimeout(timer); };
      box.classList.add('hn-sp--on');
      st.n = (st.n || 0) + 1; st.last = Date.now(); seen.push(e.h + '|' + e.n); st.seen = seen.slice(-20); save();
      setTimeout(hide, SHOW);
      if ((st.n || 0) < MAX && idx < order.length) timer = setTimeout(show, GAP);
    }
    var wait = FIRST;
    if (st.last) wait = Math.max(4000, GAP - (Date.now() - st.last));
    timer = setTimeout(show, wait);
  } catch (e) {}
})();
